export const wordCloud = {
    word: {
        padding: 1,
        style: {
            textAlign: "center",
            textBaseline: "alphabetic"
        }
    }
};
//# sourceMappingURL=word-cloud.js.map
